import React, { createContext, useState, useContext } from "react";

// Create UserContext
const UserContext = createContext();

// Create a provider component
export const UserProvider = ({ children }) => {
    const [user, setUser] = useState(null); // Initial user state is null

    // Function to update user info
    const updateUser = (userInfo) => setUser(userInfo);

    const [jwt, setJWT] = useState(null); // Initial JWT state is null

    const [scopes, setScopes] = useState(null); 
    
    const [emailAddress, setEmailAddress] = useState(null); 

    const [userSessionId, setUserSessionId] = useState(null); 
    
    const updateUserSessionId = (userSessionId)  => {console.log('set 0 ***'+userSessionId);setUserSessionId(userSessionId)};
    const updateJWT = (newJWT) => {setJWT(newJWT)};
    const updateScopes = (scopes) => {console.log('set 1 ***');setScopes(scopes)};
    const updateEmailAddress = (emailAddress) => {console.log('set 2 ***');setEmailAddress(emailAddress)};

    const resetUserContext = () => {setUser(null); 
                                    setJWT(null);
                                    setScopes(null);
                                    setEmailAddress(null);
                                    setUserSessionId(null)};

    const closeUserSession = () => {
        sessionStorage.removeItem("jwt");
        sessionStorage.removeItem("AUTHORIZATION_INITIALIZED");
        sessionStorage.removeItem("AuthorizationCode");
        sessionStorage.removeItem("AuthorizationRedirection");
        sessionStorage.removeItem("CLIENT_REDIRECT");     
        sessionStorage.removeItem("User-Session-ID");   

        resetUserContext();
    };

    return (
        <UserContext.Provider value={{ user, updateUser, 
                                        jwt, updateJWT, 
                                        scopes, updateScopes, 
                                        userSessionId, 
                                        updateUserSessionId, 
                                        emailAddress,
                                        updateEmailAddress, 
                                        closeUserSession }}>
            {children}
        </UserContext.Provider>
    );
};

// Hook to use the UserContext
export const useUser = () => useContext(UserContext);
